import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';

import './transaction-value-line-chart.scss';

const TransactionValueLineChart = ({ dealRoomStatistics }) => {
  const { concludedDealsMapping, ongoingDealsMapping } = dealRoomStatistics.dealRoomGraphInformationVO;

  let data = [];
  for (const property in concludedDealsMapping) {
    const month = concludedDealsMapping[property].month;
    const name = month.toLowerCase().charAt(0).toUpperCase() + month.slice(1).toLowerCase();

    data.push({
      'Concluded Deals': concludedDealsMapping[property].value,
      'Ongoing Deals': ongoingDealsMapping[property].value,
      name,
    });
  }

  return (
    <section className="transaction-value-line-chart">
      <ResponsiveContainer width="100%" height={300}>
        <LineChart width={600} height={300} data={data}>
          <CartesianGrid vertical={false} />
          <XAxis dataKey="name" axisLine={false} tickLine={false} />
          <YAxis width={90} axisLine={false} tickLine={false} tickFormatter={(tick) => '$' + tick} />
          <Tooltip formatter={(value) => '$' + value} />
          <Legend />
          <Line
            type="linear"
            dataKey="Concluded Deals"
            fill="#F8B754"
            stroke="#F8B754"
            legendType="plainline"
            isAnimationActive={false}
          />
          <Line
            type="linear"
            dataKey="Ongoing Deals"
            fill="#4BCEC0"
            stroke="#4BCEC0"
            legendType="plainline"
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </section>
  );
};

TransactionValueLineChart.propTypes = {
  dealRoomStatistics: PropTypes.shape({}).isRequired,
};

export default TransactionValueLineChart;
